export default {"src":"/_next/static/media/feature.f3af6d93.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};